
export default class HandleAutoComplete {
  constructor() {
    google.maps.event.addDomListener(window, 'load', function () {

      // Initiate google maps autocomplete
      var input = document.getElementById('step_three_location');
      new google.maps.places.Autocomplete(input);

      // Stop from submitting form
      input.addEventListener('keypress', (e) => {
        if (e.keyCode == '13') {
          e.preventDefault
        }
      });
    });

  }
}
